import type { IconData } from '@stacksjs/iconify-core'

export const smokingArea: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M38.591 3C37.38 6.653 37.96 10.463 41 14s3.621 7.347 2.409 11M30.591 3C29.38 6.653 29.96 10.463 33 14s3.621 7.347 2.409 11m5.784 6.203C43.327 31.262 45 33.01 45 35.146v5.709c0 2.135-1.673 3.883-3.807 3.942C37.77 44.89 32.039 45 24 45c-7.99 0-13.374-.109-16.524-.202c-2.153-.064-4.021-1.369-4.287-3.506A27 27 0 0 1 3 38c0-1.3.078-2.392.19-3.292c.265-2.137 2.133-3.442 4.286-3.506C10.626 31.109 16.01 31 24 31c8.04 0 13.77.11 17.193.203\"/><path d=\"M36.136 44.906A156 156 0 0 1 36 38c0-2.963.062-5.242.136-6.906\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default smokingArea
